import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";

import Chart from "react-apexcharts";
const chartConfig = {
  options: {
    chart: {
      id: "basic-bar",
    },

    toolbar: {
      show: false,
      tooltip: {
        enabled: false,
      },
      tools: {
        download: false,
        selection: false,
        zoom: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        reset: false,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    stroke: {
      width: 2,
      curve: "smooth" as const,
    },
  },
  series: [
    {
      name: "Total Bookings",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "Canceled Bookings",
      color: "#FF0000",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ],
};

export default function ChartComponent() {
  const [chartWidth, setChartWidth] = useState(0);

  useEffect(() => {
    const updateChartWidth = () => {
      const container = document.querySelector(
        ".chart-container"
      ) as HTMLElement;
      if (container) {
        setChartWidth(container.offsetWidth);
      }
    };

    // Use ResizeObserver to observe changes to the .chart-container
    const resizeObserver = new ResizeObserver(updateChartWidth);
    const container = document.querySelector(".chart-container");
    if (container) {
      resizeObserver.observe(container);
    }

    // Cleanup: Disconnect the observer when the component unmounts
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Card placeholder={undefined} className="mt-10">
      <CardHeader
        placeholder={undefined}
        floated={false}
        shadow={false}
        color="transparent"
        className="flex flex-col gap-4 rounded-none md:flex-row md:items-center"
      >
        <Typography
          placeholder={undefined}
          className="m-3 font-bold text-black text-xl"
        >
          Total Bookings breakdown
        </Typography>
      </CardHeader>
      <div className="w-[98%]">
        <CardBody placeholder={undefined} className="px-2 pb-0 m-1">
          <Chart
            options={chartConfig.options}
            series={chartConfig.series}
            type={"line"}
            height={400}
            className="chart-container"
            width={chartWidth}
          />
        </CardBody>
      </div>
    </Card>
  );
}
